import betslipsService from "@/services/betslips/index.service";
import store from "@/store";
import EventBus from "@/utils/EventBus";
import { notifyApiError } from "@/utils/notify";
import { requestAppLayoutUpdate } from "@/utils/app-layout";

export type BetslipBetPayload = {
  bets: Array<{
    wager: number;
    event_id: number | string;
    market_options_id: number | string;
    combination: boolean;
    numbers: number[][] | number[][][];
  }>;
};

export type SubmitToBetslipOptions = {
  isCombination?: boolean;
  outcome?: Record<string, unknown> | null;
};

type ApiError = {
  code?: string;
  messages?: string[];
};

export default {
  methods: {
    async submitToBetslip(
      payload: BetslipBetPayload,
      options: SubmitToBetslipOptions = {}
    ) {
      const { isCombination = false, outcome = null } = options;

      store.commit("setBetslipApiLoading", true);
      try {
        const res = await betslipsService.getBetslip(payload);
        if (res.status === "success") {
          await store.dispatch("appendFromApiResult", {
            apiResult: res.result,
            isCombination,
            outcome,
          });
          requestAppLayoutUpdate();
          return true;
        }
        return false;
      } catch (error) {
        const apiError = error as ApiError;
        if (apiError.code === "EVENT_EXPIRED") {
          EventBus.emit("show-refresh-page");
        }
        notifyApiError(apiError);
        return false;
      } finally {
        store.commit("setBetslipApiLoading", false);
      }
    },
  },
};
